var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#3D6CA3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3528_165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4785 12.793C28.1571 12.9215 27.9 13.0501 27.6428 13.1787C28.9928 16.5215 28.9928 19.8001 27.6428 23.143C27.9 23.2715 28.1571 23.4001 28.4785 23.5287C29.8928 19.8644 29.8928 16.393 28.4785 12.793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93564 13.1787C8.74279 13.0501 8.48564 12.9215 8.2285 12.793C6.74993 15.3001 6.68564 20.7644 8.2285 23.4001C8.48564 23.2715 8.74279 23.143 8.99993 23.0787C7.64993 19.7358 7.64993 16.4573 8.93564 13.1787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8072 13.5C26.4857 13.6286 26.2286 13.7571 25.9714 13.8857C27 16.7786 27 19.6071 25.9714 22.4357C26.2286 22.5643 26.4857 22.6929 26.8072 22.8214C27.9643 19.6071 27.9643 16.5857 26.8072 13.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83575 13.5C8.61432 15.6857 8.61432 20.6357 9.83575 22.7571C10.0929 22.6286 10.35 22.5 10.6072 22.4357C9.57861 19.6071 9.57861 16.7786 10.6072 13.8857C10.35 13.7571 10.0929 13.6286 9.83575 13.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2857 28.4786C19.0928 28.4786 18.9 28.4144 18.5786 28.3501L16.5857 27.9644C15.1714 27.7072 13.7571 27.3858 12.2786 27.1286C11.8286 27.0644 11.5714 26.8072 11.5714 26.3572C11.5714 20.8286 11.5714 15.3644 11.5714 9.83578C11.5714 9.38578 11.7643 9.12864 12.2143 9.06436C13.8214 8.74293 15.3643 8.4215 16.9714 8.10007L18.8357 7.71436C19.0286 7.71436 19.1571 7.71436 19.2214 7.71436C19.7357 7.71436 19.8 8.03578 19.8 8.61436V27.4501C19.8 27.9001 19.8 28.0929 19.7357 28.2858C19.6714 28.4786 19.4786 28.4786 19.2857 28.4786ZM18.6428 27.2572V9.00007L12.7928 10.1572V26.1001L18.6428 27.2572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1215 27.1287V25.9716H23.85V10.2859H20.1857V9.06445H23.1429C23.5286 9.06445 23.85 9.06445 24.2357 9.06445C24.8143 9.06445 25.0072 9.3216 25.0072 9.83588C25.0072 15.3645 25.0072 20.8287 25.0072 26.3573C25.0072 26.5502 25.0072 27.1287 24.4286 27.1287C23.7857 27.1287 23.1429 27.1287 22.5643 27.1287H20.1215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3571 19.993C17.0357 19.993 16.7786 19.7359 16.7786 19.4145V17.6145C16.7786 17.293 17.0357 17.0359 17.3571 17.0359C17.6786 17.0359 17.9357 17.293 17.9357 17.6145V19.4145C17.9357 19.7359 17.6786 19.993 17.3571 19.993Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3528_165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 20.7643,
    fill: "white",
    transform: "translate(7.07141 7.71436)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.f5578e2b159ee225f09a98f72cb1b825.svg";
export { ForwardRef as ReactComponent };